module.exports = __webpack_public_path__ + "img/img91.bce770a2.svg";